import React from 'react';
import { Redirect } from 'react-router-dom';

import route from './route';
import { withAppBar } from '../components/PrimaryAppBar';

const PrivateRoute = props => {
    const { component, ...rest } = props;
    const [openNavBarMobile, setopenNavBarMobile] = React.useState(false)

    const checkAuth = () => {
        const authLoacal = localStorage.getItem('token');
        if(authLoacal?.length > 0){
            return true;
        }else{
            return false;
        }
    }
    const Component = props => withAppBar(component, { ...props, openNavBarMobile, setopenNavBarMobile });

    return checkAuth() ? <Component {...rest} /> : <Redirect to={route.login} />
}


export default PrivateRoute;